<nav class="navbar navbar-dark navbar-expand-lg jh-navbar">

    <a class="navbar-brand logo" routerLink="/" (click)="collapseNavbar()">
        <span class="navbar-mark">FDE</span>
        <span class="navbar-title">Financial Data Extractor</span>
    </a>

    <a class="navbar-toggler d-lg-none" href="javascript:void(0);" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleNavbar()">
        <i class="fa fa-bars"></i>
    </a>

    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed">
        <ul class="navbar-nav ms-auto">
            @if (isAuthenticated()) {
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="deployments" (click)="collapseNavbar()">
                        <i class="fa fa-rocket"></i>
                        <span>Deployments</span>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="running" (click)="collapseNavbar()">
                        <i class="fa fa-clock-o"></i>
                        <span>Running</span>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="logs" (click)="collapseNavbar()">
                        <i class="fa fa-file-text-o"></i>
                        <span>Logs</span>
                    </a>
                </li>

                <li ngbDropdown class="nav-item dropdown" [autoClose]="'outside'" #dataDrop="ngbDropdown">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="data-menu">
                        <i class="fa fa-database"></i>
                        <span>Data</span>
                    </a>
                    <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="data-menu">
                        <li>
                            <a class="dropdown-item" routerLink="customer" routerLinkActive="active"
                               (click)="collapseNavbar(); dataDrop.close()">
                                <i class="fa fa-users"></i>
                                <span>Customers</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="company" routerLinkActive="active"
                               (click)="collapseNavbar(); dataDrop.close()">
                                <i class="fa fa-building"></i>
                                <span>Companies</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="extractor" routerLinkActive="active"
                               (click)="collapseNavbar(); dataDrop.close()">
                                <i class="fa fa-university"></i>
                                <span>Extractors</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="acct" routerLinkActive="active"
                               (click)="collapseNavbar(); dataDrop.close()">
                                <i class="fa fa-address-card-o"></i>
                                <span>Accounts</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="fde-exception" routerLinkActive="active"
                               (click)="collapseNavbar(); dataDrop.close()">
                                <i class="fa fa-exclamation-triangle"></i>
                                <span>Exceptions</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="nightly-refresh" routerLinkActive="active"
                               (click)="collapseNavbar(); dataDrop.close()">
                                <i class="fa fa-moon-o"></i>
                                <span>Nightly Refresh</span>
                            </a>
                        </li>
                        <li ngbDropdown class="dropdown-submenu" placement="left-top" [autoClose]="'outside'"
                            #savedDrop="ngbDropdown">
                            <a class="dropdown-item dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="saved-menu">
                                <i class="fa fa-folder-open-o"></i>
                                <span>Saved data</span>
                            </a>
                            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="saved-menu">
                                <li>
                                    <a class="dropdown-item" routerLink="sub-acct" routerLinkActive="active"
                                       (click)="collapseNavbar(); savedDrop.close(); dataDrop.close()">
                                        <i class="fa fa-sitemap"></i>
                                        <span>Sub Accounts</span>
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" routerLink="statement" routerLinkActive="active"
                                       (click)="collapseNavbar(); savedDrop.close(); dataDrop.close()">
                                        <i class="fa fa-file-pdf-o"></i>
                                        <span>Statements</span>
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" routerLink="check" routerLinkActive="active"
                                       (click)="collapseNavbar(); savedDrop.close(); dataDrop.close()">
                                        <i class="fa fa-money"></i>
                                        <span>Checks</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>

                <li ngbDropdown class="nav-item dropdown pointer">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="metrics-menu">
                        <i class="fa fa-line-chart"></i>
                        <span>Metrics</span>
                    </a>
                    <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="metrics-menu">
                        <li>
                            <a class="dropdown-item" routerLink="lsda-statistics" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-bar-chart"></i>
                                <span>LSDA Statistics</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="account-metrics" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-line-chart"></i>
                                <span>Account Metrics</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li ngbDropdown class="nav-item dropdown pointer">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="admin-menu">
                        <i class="fa fa-sliders"></i>
                        <span>Administration</span>
                    </a>
                    <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="admin-menu">
                        <li style="display: none;">
                            <a class="dropdown-item" routerLink="admin/gateway" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-road"></i>
                                <span>Gateway</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="desktop-app-releases" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-desktop"></i>
                                <span>Desktop App Releases</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="extractor-deploy" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-cloud-upload"></i>
                                <span>Extractor Deploy</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="agent" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-android"></i>
                                <span>Agent</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="account-cookies" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-database"></i>
                                <span>Account Cookies</span>
                            </a>
                        </li>
                        <li><h6 class="dropdown-header">External tools</h6></li>
                        <li>
                            <a class="dropdown-item" [href]="kafka" target="_blank" rel="noopener" (click)="collapseNavbar()">
                                <i class="fa fa-exchange"></i>
                                <span>Kafka</span>
                                <i class="fa fa-external-link external-marker"></i>
                            </a>
                        </li>
                    </ul>
                </li>
            }
            <li ngbDropdown class="nav-item dropdown pointer" placement="bottom-right">
                <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu">
                  @if (!getImageUrl()) {
                      <i class="fa fa-user-circle-o"></i>
                      <span>Account</span>
                  } @else {
                      <span>
                          <img [src]="getImageUrl()" class="profile-image rounded-circle" alt="Avatar">
                      </span>
                  }
                </a>
                <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="account-menu">
                    @if (isAuthenticated()) {
                        <li>
                            <a class="dropdown-item" routerLink="settings" routerLinkActive="active" (click)="collapseNavbar()">
                                <i class="fa fa-wrench"></i>
                                <span>Settings</span>
                            </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                            <a class="dropdown-item" (click)="logout()" id="logout">
                                <i class="fa fa-sign-out"></i>
                                <span>Sign out</span>
                            </a>
                        </li>
                    } @else {
                        <li>
                            <a class="dropdown-item" (click)="login()" id="login">
                                <i class="fa fa-sign-in"></i>
                                <span>Sign in</span>
                            </a>
                        </li>
                    }
                </ul>
            </li>
        </ul>
    </div>
</nav>
